import React from "react";
import { connect } from "react-redux";
import { movil } from "../app-movil";
import { validarOtp, reenviarOtp } from "./datos.act";
import { validarOtpBan } from "../home/polizas.act";

import "../home/estilos_h.css"

const mapState = (state) => {
	return {
		paso: state.miPerfil.pasoCodigo,
		lada: state.miPerfil.lada,
		celular: state.miPerfil.celular,
		objeto: state.miPerfil.objTemporal,
		loadLocal: state.miPerfil.loadLocal,
		idOperacion: state.miPerfil.idOperacion,
		codOtp: state.miPerfil.codOtp,
		numCelOtp: state.miPerfil.numCelOtp,
		correoOtp: state.miPerfil.correoOtp,
		error: state.miPerfil.error,
		refreshToken: state.global.refreshToken,
		item: state.polizas.poliza,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		reenviarOtp: (num, cod, mail) => {
			dispatch(reenviarOtp(num, cod, mail));
		},
		setloadLocal: (val) => {
			dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", load: val });
		},
		validarOtp: (codigo, idOperacion, obj) => {
			dispatch(validarOtp(codigo, idOperacion, obj));
		},
		validarOtpBan: (codigo, idOperacion, rt, item) => {
			dispatch(validarOtpBan(codigo, idOperacion, rt, item));
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento });
		},
		addEventoOTP: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		},
		clearError: () => {
			dispatch({ "type": "MI_PERFIL_SET_ERROR", error: false });
		}
	};
};

class PasoUnoCodigo extends React.Component {
	state = {
		inputClass: "input-wrap",
		inputActive: "",
		inputType: "text",
		codigoMal: false,
		error: false
	}
	changeInputType = () => {
		let type = this.state.inputType;
		this.setState({ inputType: type == "password" ? "text" : "password" });
		this.setState({ inputClass: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input" });
	}
	handleFocus = (event) => {
		this.setState({ inputActive: "input-active" });
		this.setState({ error: false });
	}
	handleBlur = (event) => {
		let valor = event.target.value;
		this.setState({ inputActive: valor ? "input-active" : "" });
	}
	checkCode = () => {

		let codigo = this.refs.codigo.value;
		console.log("codigo" + codigo);
		if (!codigo) {
			console.log("No entro al switch");
			this.setState({ error: true });
			if (this.props.pol) {
				switch (this.props.item.generales.detalle) {
					case "inversion":
						if (this.props.item.generales.cveProdTecnico == "CT65I") {
							this.props.addEventoOTP("CampoRequerido-CodigoOTP-Consolida");
						}
						else if (this.props.item.generales.cveProdTecnico == "FB20I" || this.props.item.generales.cveProdTecnico == "FB65I") {
							this.props.addEventoOTP("CampoRequerido-CodigoOTP-Elige");
						}
						else {
							this.props.addEventoOTP("CampoRequerido-CodigoOTP-VInversion");
						}
						break;
					case "capitaliza":
						this.props.addEventoOTP("CampoRequerido-CodigoOTP-Capitaliza");
						break;
					default:
						this.props.addEventoOTP("CampoRequerido-CodigoOTP-Vida");
						break;
				}
			}
			else {
				this.props.addEvento("CampoRequerido-CodigoOTP-DP");
			}
		} else {
			console.log("Entrará a checar el código");
			this.props.setloadLocal(true);
			this.props.clearError();
			if (this.props.pol) {
				this.props.validarOtpBan(codigo, this.props.idOperacion, this.props.refreshToken, this.props.item);
			}
			else {
				this.props.validarOtp(codigo, this.props.idOperacion, this.props.objeto, this.props.dispositivo);
			}
		}
	}
	_handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.checkCode();
		}
	}
	cancelar = () => {
		this.refs.codigo.value = "";
		this.props.clearError();
		let mensaje = { "return": "miPerfil", "proceso": "#modal-codigo-dp" };
		movil("#modal-codigo-dp", mensaje);
		if (this.props.pol) {
			$("#modal-codigo-pol").modal("hide");
			switch (this.props.item.generales.detalle) {
				case "inversion":
					if (this.props.item.generales.cveProdTecnico == "CT65I") {
						this.props.addEventoOTP("Cancelar-CodigoOTP-Consolida");
					}
					else if (this.props.item.generales.cveProdTecnico == "FB20I" || this.props.item.generales.cveProdTecnico == "FB65I") {
						this.props.addEventoOTP("Cancelar-CodigoOTP-Elige");
					}
					else {
						this.props.addEventoOTP("Cancelar-CodigoOTP-VInversion");
					}
					break;
				case "capitaliza":
					this.props.addEventoOTP("Cancelar-CodigoOTP-Capitaliza");
					break;
				default:
					this.props.addEventoOTP("Cancelar-CodigoOTP-Vida");
					break;
			}
		} else {
			this.props.addEvento("Cancelar-CodigoOTP-DP");
			$("#modal-codigo-dp").modal("hide");
		}
	}

	reenviarCodigo = () => {
		this.props.setloadLocal(true);
		if (this.props.pol) {
			switch (this.props.item.generales.detalle) {
				case "inversion":
					if (this.props.item.generales.cveProdTecnico == "CT65I") {
						this.props.addEventoOTP("Reenviar-CodigoOTP-Consolida");
					}
					else if (this.props.item.generales.cveProdTecnico == "FB20I" || this.props.item.generales.cveProdTecnico == "FB65I") {
						this.props.addEventoOTP("Reenviar-CodigoOTP-Elige");
					}
					else {
						this.props.addEventoOTP("Reenviar-CodigoOTP-VInversion");
					}
					break;
				case "capitaliza":
					this.props.addEventoOTP("Reenviar-CodigoOTP-Capitaliza");
					break;
				default:
					this.props.addEventoOTP("Reenviar-CodigoOTP-Vida");
					break;
			}
		} else {
			this.props.addEvento("Reenviar-CodigoOTP-DP");
		}
		this.props.reenviarOtp(this.props.numCelOtp, this.props.codOtp, this.props.correoOtp);
	}

	handleChange = (event) => {
		let id = event.target.id;
		let value = event.target.value;
		let ultimo;

		ultimo = value[value.length - 1];
		if (value) {
			for (var i = 0; i < value.length; i++) {
				if (isNaN(value[i]) || value[i] == " ") {
					event.target.value = value.replace(value[i], "");
					value = event.target.value;
					i = -1;
				}
			};
		}
	}

	render() {
		return <div>
			<h5>
				<i>
					<img src={require("../img/code-icon.png")} />
				</i>Código de verificación
			</h5>
			{this.props.error &&
				<div className="msj-warning">
					<i className="no-pad"><img src={require("../img/exclamation-naranja.png")} /></i>
					<span>
						El número de OTP es incorrecto .Intentalo nuevamente.<br />
						Por seguridad se bloqueará a los 3 intentos fallidos.
					</span>
				</div>
			}
			<div className="texto-17 mt-34">
				<p>Recibirás un mensaje en tu celular <span className="orange-text">(+{this.props.numCelOtp}).</span> con un número de OTP, captúralo y da clic en validar.</p>

				<p>En caso de captura incorrecta genera uno nuevo seleccionando "Reenviar OTP".</p>

			</div>
			{this.props.loadLocal &&
				<div className="table-center">
					<img src={require("../img/load_mini.gif")} />
				</div>
			}
			{!this.props.loadLocal &&
				<div className="row">
					<div className="col-xs-12 col-md-10 col-md-offset-1">
						<div className="row">
							<div className="col-xs-12 mt-50">
								<div id="input-wrap-c" className={this.state.inputClass}>
									<label>Código de verificación (OTP)</label>
									<span className={this.state.inputActive}>
										<input ref="codigo" maxLength="8" type={this.state.inputType} onFocus={this.handleFocus} onBlur={this.handleBlur} onKeyPress={this._handleKeyPress} onChange={this.handleChange} />
										{/*<button className="btn-ojo" onClick={this.changeInputType}></button>*/}
									</span>
									{this.state.error &&
										<div className="error-wrap">
											<div className="msj-error">
												<p>Campo requerido.</p>
											</div>
										</div>
									}
								</div>
							</div>
							<div className="col-xs-12">
								<div id="aceptar-cancelar-btn-c" className="text-center aceptar-cancelar-btn mt-50">
									<a onClick={this.cancelar} id="btnCancelarCodigo">Cancelar</a>
									<a onClick={this.checkCode} className="orange-btn">Validar</a>
								</div>
							</div>

							<div className="col-xs-12" id="divReenviar">
								<div className="text-center texto-17 mt-34">
									<p>¿Tienes problemas? <a className="orange-text" onClick={this.reenviarCodigo}>Reenviar OTP</a></p>
									{this.state.timeoutReenviar}
								</div>
							</div>

						</div>
					</div>
				</div>
			}
		</div>;
	}
}

export default connect(mapState, mapDispatch)(PasoUnoCodigo);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoUnoCodigo.cmpt.js